<template>
	<div>
		<Navigation />
		<div class="content">
			<router-view />
		</div>
	</div>
</template>

<script>
import "./assets/scss/front.scss";
import Navigation from "./components/Navigation";

export default {
	name: "App",
	components: {
		Navigation
	}
};
</script>
